<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>项目管理</el-breadcrumb-item>
      <el-breadcrumb-item>项目列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="区域">
            <RegionSelect v-model="filter.region" :search="true"></RegionSelect>
          </el-form-item>
          <el-form-item label="井及状态" v-if="archive != 2">
            <StatusSelect v-model="filter.status" :search="true"></StatusSelect>
          </el-form-item>
          <el-form-item label="井号">
            <el-input
              size="small"
              v-model="filter.pit_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="开始日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <el-button
        v-if="archive == 1"
        v-code="21101"
        type="primary"
        size="small"
        @click="$router.push('/report/projects/new')"
      >
        添加项目
      </el-button>
      <ListTable :items="list" :archive="archive == 2"></ListTable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { projectList } from '@/service/getData'
import ListTable from './table'
import RegionSelect from '@/components/select/RegionSelect'
import StatusSelect from './status_select.vue'
export default {
  props: {
    archive: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ListTable,
    RegionSelect,
    StatusSelect,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        region: 0,
        status: 0,
        pit_number: '',
        date: '',
      },
      total: 0,
      list: [],
      statusOptions: [
        { id: 0, name: '全部' },
        { id: 1, name: '待钻' },
        { id: 2, name: '在钻' },
        { id: 3, name: '完钻' },
      ],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.region = 0
        this.filter.status = 0
        this.filter.pit_number = ''
        this.filter.date = ''
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      params.archive = this.archive
      if (params.date && params.date.length == 2) {
        params.date_start = params.date[0]
        params.date_end = params.date[1]
      }

      let res = await projectList(params)
      this.list = res.data.list
      this.total = res.data.count
    },
  },
}
</script>